import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";

import { Button, Toastr, Loader } from "@revvsales/components";

// Action Imports
// import { updateSubmitRejectSignerFiller } from "../../actions/DocumentActions/services";
import {
  updateSubmitRejectSignerFillerAction,
  updateSubmitDeclineInternalAction,
} from "../../actions/DocumentActions";
import SubmitConfirmationPopup from "./SubmitConfirmationPopup";
import { readDataFromLocalStorage } from "../../utils/globalUtils";
import { getExportContent } from "../../utils/documentUtils";
import { getOrderedSignersList } from "../../utils/quotationUtils";

class SubmitDeclineConfirmation extends Component {
  state = { errMsg: "", isLoading: false };

  _submitDeclineDoc = () => {
    // Make api call here
    const {
      view,
      docID,
      sharingHash,
      docName,
      document: doc,
      layout,
      components,
      updateSubmitRejectSignerFiller,
      isSharing,
      updateSubmitDeclineInternal,
    } = this.props;
    const documentSectionHTML = document.getElementsByClassName(
      "document-view-main-container",
    )[0];
    const html =
      documentSectionHTML && documentSectionHTML.innerHTML.length > 0
        ? documentSectionHTML.innerHTML
        : "";
    const signers = getOrderedSignersList(doc.signatories, layout);

    const data = {
      esignType: "OS",
      pdfFile: getExportContent(doc, components, html),
      docName,
    };
    data.pdfFile.content.signers = signers.reduce((accum, item) => {
      accum[item.user_email] = item;
      return accum;
    }, {});

    this.setState({
      isLoading: true,
    });
    if (isSharing) {
      updateSubmitRejectSignerFiller(docID, sharingHash, view, data)
        .then(() => {
          if (this.props.view === "submit") {
            this.props.updateMultipleState({
              docSubmittedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          } else if (this.props.view === "decline") {
            this.props.updateMultipleState({
              docDeclinedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          }
          this.setState({
            isLoading: false,
          });
        })
        .catch(() => {
          Toastr.showToastr({
            className: "is-failure",
            message: `Oops! Couldn't ${
              this.props.view
            } document. Please try again.`,
            timeout: 3000,
          });
          this.setState({ isLoading: false });
          this.props.updateMultipleState({
            submitDeclineConfirmation: false,
            showSubmitAndDeclineBtn: false,
          });
        });
    } else {
      const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

      updateSubmitDeclineInternal(docID, view, CURRENT_USER.id, data)
        .then(() => {
          if (this.props.view === "submit") {
            this.props.updateMultipleState({
              docSubmittedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          } else if (this.props.view === "decline") {
            this.props.updateMultipleState({
              docDeclinedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          }
          this.setState({
            isLoading: false,
          });
        })
        .catch(() => {
          Toastr.showToastr({
            className: "is-failure",
            message: `Oops! Couldn't ${
              this.props.view
            } document. Please try again.`,
            timeout: 3000,
          });
          this.setState({ isLoading: false });
          this.props.updateMultipleState({
            submitDeclineConfirmation: false,
            showSubmitAndDeclineBtn: false,
          });
        });
    }

    // use update multiple state to close
    this.props.updateMultipleState({
      showSubmitAndDeclineBtn: false,
    });
  };

  _checkFormFields = () => {
    // if true - dont show the send confirmation popup
    const { fieldsUsed, showForm } = this.props;
    if (!fieldsUsed || !fieldsUsed.length || !showForm) {
      return true;
    }
    for (let i = 0; i < fieldsUsed.length; i += 1) {
      const element = fieldsUsed[i];
      if (element && !element.value && element.filler_type === "RECIPIENT") {
        if (!(element.meta && element.meta.default)) {
          return false;
        }
      }
    }
    return true;
  };

  render() {
    if (!this._checkFormFields() && this.props.view === "submit") {
      const unfilledValue = [];
      const recipentAssignedCount = [];
      this.props.fieldsUsed.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          recipentAssignedCount.push(element);
        }
        if (
          element.value &&
          element.value.length !== 0 &&
          element.filler_type === "RECIPIENT"
        ) {
          unfilledValue.push(element);
        }
      });
      const finalFillerValue =
        recipentAssignedCount.length - unfilledValue.length;
      return (
        <SubmitConfirmationPopup
          onConfirm={this._submitDeclineDoc}
          isLoading={this.state.isLoading}
          onClose={() => {
            this.props.togglePopUp("submitDeclineConfirmation", false);
          }}
          unfilledValue={finalFillerValue || null}
        />
      );
    }
    return (
      <Modal
        open
        onClose={() =>
          this.props.togglePopUp("submitDeclineConfirmation", false)
        }
        center>
        {/* Loader Section */}
        {this.state.isLoading && (
          <Loader
            className="loader-bg-color"
            label={` ${
              this.state.isLoading
                ? "🔏 Processing your document for eSignature"
                : "Loading..."
            }`}
          />
        )}
        <div className="approvalpopup">
          <div className="approvalpopup-header">
            <p>
              {this.props.view === "submit" ? "Submit" : "Decline"} document
            </p>
          </div>
        </div>
        <div className="approvalpopup-note">
          <p className="approvalpopup-workflows-heading">
            {this.props.view === "submit"
              ? "You're about to submit this document. This action cannot be reversed."
              : "You're about to decline this document. This action cannot be reversed."}
          </p>
          <p className="approvalpopup-workflows-heading">
            {this.state.errMsg && (
              <div className="error-message-wrapper">
                <span className="error-message-icon">
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </span>
                {this.state.errMsg}
              </div>
            )}
          </p>
          {/* <textarea
            rows="5"
            value={this.state.comment}
            onChange={e => this._changeComment(e)}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          /> */}
        </div>
        <section className="createquotepopup-footer popup-footer clearfix">
          <div className="footer-actions">
            <Button
              data-test="submitdeclineconfirmation-popup-cancelbtn"
              className="btn-transparent"
              onClick={() =>
                this.props.togglePopUp("submitDeclineConfirmation", false)
              }>
              Cancel
            </Button>
            <Button
              data-test="submitdeclineconfirmation-popup-submitbtn"
              className={`${
                this.props.view === "decline" ? "reject-document" : ""
              }`}
              onClick={() => this._submitDeclineDoc()}>
              {this.props.view === "submit" ? "Submit" : "Decline"}
            </Button>
          </div>
        </section>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    document,
    docRecipientList,
    components,
    layout,
  } = state.DocumentStore;
  const {
    id: docID,
    docNo,
    fields_used: fieldsUsed = [],
    name: docName,
    showForm,
  } = document;
  const { documentNotes } = state.NotesStore;
  return {
    docID,
    docNo,
    document,
    docName,
    documentNotes,
    docRecipientList,
    fieldsUsed,
    components,
    showForm,
    layout,
  };
};

export const mapDispatchToProps = {
  updateSubmitRejectSignerFiller: updateSubmitRejectSignerFillerAction,
  updateSubmitDeclineInternal: updateSubmitDeclineInternalAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubmitDeclineConfirmation);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/SubmitDeclineConfirmation.js